import { TableColumn, TableRow } from '@aon/aon-tws-common-ui';
import React from 'react';
import { IColumn, IUserListItem } from '../../../models';

export interface IUserListRowProps {
	user: IUserListItem;
	columns: IColumn[];
	isSelected: boolean;
	onSelectRow: (isSelected: boolean) => void;
}

export const UserListRow = (props: IUserListRowProps) => {
	return (
		<TableRow key={props.user.userId} selectable={true} selected={props.isSelected} onSelectRow={() => props.onSelectRow(props.isSelected)}>
			{props.columns.map((c, index) => getColumn(index, c, props.user))}
		</TableRow>
	);
};

function getColumn(index: number, column: IColumn, user: IUserListItem) {
	switch (column.name) {
		case 'UserId':
			return <TableColumn key={index}>{user.userId}</TableColumn>;
		case 'FirstName':
			return <TableColumn key={index}>{user.firstName}</TableColumn>;
		case 'LastName':
			return <TableColumn key={index}>{user.lastName}</TableColumn>;
		case 'Email':
			return <TableColumn key={index}>{user.email}</TableColumn>;
		case 'Status':
			return <TableColumn key={index}>{user.status}</TableColumn>;
	}
}
